import styled from 'styled-components';

export const ScrollTabWrapper = styled.div<{
  direction: string;
  isStickySearch: boolean;
  visible: boolean;
  extraHeight: boolean;
}>`
  width: 100%;
  height: ${({ extraHeight, visible, direction }) =>
    extraHeight ? '90px' : visible && direction === 'up' ? '50px' : '81px'};
  position: fixed;
  z-index: 999999;
  transition: all 0.25s;
  background-color: ${({ theme }) => theme.palette.white};
  border-top: 1px solid ${({ theme }) => theme.palette.lightsSilver};
  box-shadow: 6px 17px 83px rgb(0, 0, 0, 51%);
  top: ${({ isStickySearch, visible, direction }) =>
    visible && !isStickySearch && direction === 'down'
      ? '0'
      : visible && direction === 'up'
      ? '98px'
      : '-100px'};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    top: ${({ visible }) => (visible ? '136px' : '-1000px')};
    z-index: 11;
    overflow-x: auto;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    &::-webkit-scrollbar {
      display: none; /* for Chrome, Safari, and Opera */
    }
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    width: 500px;
  }
`;

export const ContainerBorder = styled.div<{
  visible: boolean;
}>`
  position: absolute;
  top: 55%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.lightsSilver};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  z-index: 2300;
  transition: all 0.05s;
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  max-width: 1024px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 10px 23px 0 23px;
  justify-content: space-between;

  & a {
    font-size: 16px;
    color: ${({ theme }) => theme.palette.darkGray};
    padding-bottom: 10px;
  }

  & .active {
    color: ${({ theme }) => theme.palette.primaryBrand};
    font-weight: bold;
    border-bottom: 4px solid ${({ theme }) => theme.palette.primaryBrand};
    padding-bottom: 10px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    overflow-x: auto;
    white-space: nowrap;

    width: 100vw;
    margin: 0;
    max-width: unset;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    &::-webkit-scrollbar {
      display: none; /* for Chrome, Safari, and Opera */
    }
    & a {
      padding-right: 0;
      padding-bottom: 14px;

      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }
`;
